import { IAgencyCostImperial } from '@/modules/agencyCost/interfaces/agencyCost';
import { between, maxValue, minValue, required } from 'vuelidate/lib/validators';

const currYear = new Date(Date.now()).getFullYear();

export const createAgencyCostValidators = function (scenario: IAgencyCostImperial) {
  return {
    scenarioImperial: {

      name: { required },
      analysisYear: {
        required,
        between: between(0, 200),
      },
      discountRate_pct: {
        required,
        between: between(0, 100),
      },
      startYear: {
        required,
        minValue: minValue(1900),
        maxValue: maxValue(currYear + 100),
      },
      totalLength_mi: {
        required,
        minValue: minValue(0),
      },
      laneWidth_ft: {
        required,
        minValue: minValue(0),
      },
      outsideShoulderWidth_ft: {
        required,
        minValue: minValue(0),
      },
      insideShoulderWidth_ft: {
        required,
        minValue: minValue(0),
      },

      // activities: function(){
      //   return scenario.activities.map(A => {
      //     return {
      //       name: {
      //         required
      //       },
      //       yearsAfterStart: {
      //         required,
      //         minValue: minValue(0)
      //       }
      //     }
      //   })
      // }()

    },

    1: [
      'scenarioImperial.name',
      'scenarioImperial.discountRate_pct',
      'scenarioImperial.startYear',
      'scenarioImperial.totalLength_mi',
      'scenarioImperial.laneWidth_ft',
      'scenarioImperial.outsideShoulderWidth_ft',
      'scenarioImperial.insideShoulderWidth_ft',
    ],
    2: [
      
    ],
    3: [
      '1',
      '2',
    ],

  };
};
